import { Configuration, PopupRequest } from '@azure/msal-browser';

// MSAL Configuration
const redirectUri = `${window.location.origin}/login`;

export const msalConfig: Configuration = {
  auth: {
    clientId: '9ff99c65-4765-419e-b209-05cd9bfaffb2',
    // Use 'common' authority to support personal Microsoft accounts and multi-tenant
    // 'common' allows: Personal Microsoft accounts + any Azure AD organization
    authority: 'https://login.microsoftonline.com/common',
    // Centralized login page - all authentication flows redirect here
    // Dynamically uses current hostname (botrtools.com or test.botrtools.com)
    // This allows the same code to work in both production and test environments
    redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage', // Survives tab close — Firebase-first auth handles long gaps
    storeAuthStateInCookie: false, // Set to true if you need to support IE11 or Edge Legacy
  },
  system: {
    // Disable popup window features that might conflict with COOP
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    // Allow popup to work with self-signed certificates
    allowRedirectInIframe: false,
  },
};

// Scopes for login request
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'], // Request permission to read user profile
  // Popup configuration to avoid COOP issues with self-signed certs
  popupWindowAttributes: {
    // Explicitly configure popup size and position
    // This helps with OAuth popups with self-signed certificates
    popupSize: {
      height: 600,
      width: 400,
    },
  },
};

